import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ComplianceState,
  // ICompliance,
  IComplianceResponseData,
} from "../types/compliance";
import { IApiResponse } from "../types/api-response";

const initialState: ComplianceState = {
  compliances: [],
  compliance: null,
  limit: 20,
  offset: 0,
  total: 0,
  loading: false,
  loadingComplianceId: null,
};

const complianceSlice = createSlice({
  name: "compliance",
  initialState,
  reducers: {
    setCompliance: (
      state,
      action: PayloadAction<IApiResponse<IComplianceResponseData>>,
    ) => {
      state.compliances = action.payload.data.process_requests;
      state.limit = action.payload.data.limit;
      state.offset = action.payload.data.offset;
      state.total = action.payload.data.total;
    },

    setComplianceOffset: (state, action: PayloadAction<number>) => {
      state.offset = action.payload;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    setLoadingComplianceId: (state, action: PayloadAction<number | null>) => {
      state.loadingComplianceId = action.payload;
    },
  },
});

export const {
  setCompliance,
  setComplianceOffset,
  setLoading,
  setLoadingComplianceId,
} = complianceSlice.actions;

export default complianceSlice.reducer;
